import classNames from 'classnames';
import Icon, { IconNames } from 'components/Icon';
import theme from 'config/theme';
import { IRecipient } from 'store/recipients/types';

export const HeaderBar = ({
  isOpen,
  onClick,
  onPointerDown,
  onTouchStart,
  items,
}: {
  isOpen: boolean;
  onClick: () => void;
  onPointerDown?: React.PointerEventHandler<HTMLDivElement>;
  onTouchStart?: React.TouchEventHandler<HTMLDivElement>;
  items: IRecipient[];
}) => (
  <div
    className={classNames('bottom-cart-header', { 'header-open': isOpen })}
    onClick={onClick}
    onPointerDown={onPointerDown}
    onTouchStart={onTouchStart}
  >
    <div className="bottom-cart-header-content">
      <span className="eyebrow-text color-white">COMPLETE CHECKOUT</span>
      <span className="body-small-text color-white">
        {`${items.length} recipient${items.length === 1 ? '' : 's'}`}
      </span>
    </div>
    <Icon
      name={isOpen ? IconNames.ChevronDown : IconNames.ChevronUp}
      color={theme.colors.white}
      size={40}
    />
  </div>
);
